import { Box } from "@mui/material";
import React from "react";
import noLogo from "../../../../../shared/assets/images/noLogo.png"

interface CompanyLogoProps {
  src?: string;
}

const CompanyLogo = ({src}: CompanyLogoProps) => {
  const sizeImage = 74;

  return (
    <>
      <Box sx={{ height: sizeImage, width: sizeImage }}>
        <img
          className="aspect-square object-cover"
          style={{ border: "1px solid #C7C9CD", borderRadius: "4px" }}
          src={src || noLogo}
          alt=""
        />
      </Box>
    </>
  );
};
export default CompanyLogo;
